import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import AccountLeads from './components/AccountLeads';
import Accounts from './components/Accounts';
import Companies from './components/Companies';
import CompleteMarketingForm from './components/CompleteMarketingForm';
import ContactDashboard from './components/ContactDashboard';
import ContactsTable from './components/ContactsTable';
import HomePage from './components/HomePage';
import Interactions from './components/Interactions';
import LeadDetail from './components/LeadDetail';
import Leads from './components/Leads';
import MainLayout from './components/MainLayout';
import MarketingForms from './components/MarketingForms';
import Messages from './components/Messages';
import OrganizationalChart from './components/OrganizationalChart';
import SalesAnalyticsSuite from './components/SalesAnalyticsSuite';
import Settings from './components/Settings';
import Tasks from './components/Tasks';
import { CRMProvider } from './context/CRMContext';

function App() {
  return (
    <CRMProvider>
      <Router>
        <MainLayout>
          <Routes>
            {/* Default redirect to home page */}
            <Route path="/" element={<Navigate to="/home" replace />} />
            
            {/* Home Page (Main Dashboard) */}
            <Route path="/home" element={<HomePage />} />
            <Route path="/dashboard" element={<HomePage />} />
            
            {/* Sales */}
            <Route path="/tasks" element={<Tasks />} />
            <Route path="/sales/analytics" element={<SalesAnalyticsSuite />} />
            <Route path="/leads" element={<Leads />} />
            <Route path="/leads/:leadId" element={<LeadDetail />} />
            <Route path="/accounts" element={<Accounts />} />
            <Route path="/accounts/:accountId/leads" element={<AccountLeads />} />
            <Route path="/interactions" element={<Interactions />} />
            
            {/* Inbox */}
            <Route path="/messages" element={<Messages />} />
            
            {/* Contacts */}
            <Route path="/contacts" element={<ContactsTable />} />
            <Route path="/contacts/org-chart" element={<OrganizationalChart />} />
            <Route path="/contacts/companies" element={<Companies />} />
            <Route path="/contacts/forms" element={<MarketingForms />} />
            <Route path="/contacts/:contactId" element={<ContactDashboard />} />
            
            {/* Legacy routes for forms */}
            <Route path="/marketing/forms/complete" element={<CompleteMarketingForm />} />
            <Route path="/tasks/form/:taskId" element={<CompleteMarketingForm />} />
            
            {/* Settings */}
            <Route path="/settings" element={<Settings />} />
            
            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Routes>
        </MainLayout>
      </Router>
    </CRMProvider>
  );
}

export default App;
